'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useRef, useState, useEffect } from 'react';
import WindowSize from '@/utils/windowSize';

export default function CollectionsShowcaseClient({
  discount_badge,
  secondary_badge,
  collections
}) {
  const largeImage = useRef(null);
  const [firstImageHeight, setFirstImageHeight] = useState('');
  const windowSize = WindowSize();

  useEffect(() => {
    //required so that all images stay the same height
    if (largeImage?.current) {
      setFirstImageHeight(largeImage.current.offsetHeight);
    }
  }, [windowSize]);

  return (
    <>
      <div className="relative mb-10 w-full min-w-0 sm:mb-0 sm:w-1/2">
        {collections.map((collection, index) => {
          if (index == 0) {
            return (
              <Link
                key={index}
                href={collection?.reference[0]?.url}
                title={collection?.reference[0]?.title}
                prefetch={false}
                id={collection._metadata.uid + '_' + index}
              >
                <div className="absolute -top-px right-0 z-20">
                  {collection.secondary_badge?.show_secondary_badge && (
                    <div
                      className={`badge-text-s lg:badge-text-r inline-block h-7 content-center px-2 py-1.5 text-[${secondary_badge.text_color}] bg-[${secondary_badge.background_color}]`}
                    >
                      <div>
                        {collection.secondary_badge?.secondary_badge_text}
                      </div>
                    </div>
                  )}
                  {collection.discount_badge?.show_discount_badge && (
                    <div
                      className={`badge-text-s lg:badge-text-r inline-block h-7 content-center px-2 py-1.5 text-[${discount_badge.text_color}] bg-[${discount_badge.background_color}]`}
                    >
                      <div>
                        {collection?.discount_badge?.discount_badge_text}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  ref={largeImage}
                  className="img-hover-opacity relative aspect-video w-full"
                >
                  <Image
                    src={collection.desktop_image.url}
                    alt={collection.desktop_image.title.replace(
                      /\.[^/.]+$/,
                      ''
                    )}
                    fill
                    sizes="(min-width: 1536px) 600px, (min-width: 1280px) 536px, (min-width: 1024px) 448px,(min-width: 768px) 344px, (min-width: 640px) 280px, 600px"
                    className="object-cover"
                  />
                </div>
                <div className="pt-3">
                  <span className="max-[1024px]:h6 lg:txt-btn lg:txt-btn-primary max-[1024px]:underline">
                    {collection?.link_text}
                  </span>
                </div>
              </Link>
            );
          }
        })}
      </div>
      <div className="flex w-full min-w-0 sm:w-1/2">
        {collections.slice(1, 3).map((collection, index) => {
          return (
            <div
              key={index}
              className={`relative w-1/2 min-w-0 ${index == 1 ? 'ml-5' : ''} sm:ml-6 lg:ml-8`}
            >
              <Link
                key={index}
                href={collection?.reference[0]?.url}
                title={collection?.reference[0]?.title}
                prefetch={false}
                id={collection._metadata.uid + '_' + index}
              >
                <div className="absolute -top-px right-0 z-20">
                  {collection.secondardy_badge?.show_secondary_badge && (
                    <div
                      className={`badge-text-s lg:badge-text-r inline-block h-7 content-center px-2 py-1.5 text-[${secondary_badge.text_color}] bg-[${secondary_badge.background_color}]`}
                    >
                      <div>
                        {collection.secondary_badge?.secondary_badge_text}
                      </div>
                    </div>
                  )}
                  {collection.discount_badge?.show_discount_badge && (
                    <div
                      className={`badge-text-s lg:badge-text-r inline-block h-7 content-center px-2 py-1.5 text-[${discount_badge.text_color}] bg-[${discount_badge.background_color}]`}
                    >
                      <div>
                        {collection?.discount_badge?.discount_badge_text}
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div
                    className="img-hover-opacity relative aspect-4/5 w-full"
                    style={{
                      maxHeight: firstImageHeight,
                      minHeight: firstImageHeight
                    }}
                  >
                    <Image
                      src={collection.desktop_image.url}
                      alt={collection.desktop_image.title.replace(
                        /\.[^/.]+$/,
                        ''
                      )}
                      fill
                      sizes="(min-width: 1536px) 268px, (min-width: 1280px) 236px, (min-width: 1024px) 192px,(min-width: 768px) 160px, (min-width: 640px) 128px, 300px"
                      className="object-cover"
                    />
                  </div>
                </div>
                <div className="pt-3">
                  <span className="max-[1024px]:h6 lg:txt-btn lg:txt-btn-primary max-[1024px]:underline">
                    {collection?.link_text}
                  </span>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </>
  );
}
